<template lang="html">
  <div class="">Map View. (Future Feature)</div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
.main {
  background:#89aeb2
}
</style>
